import { render, staticRenderFns } from "./CreateConvocationList.vue?vue&type=template&id=5f151ab3&"
import script from "./CreateConvocationList.vue?vue&type=script&lang=js&"
export * from "./CreateConvocationList.vue?vue&type=script&lang=js&"
import style0 from "./CreateConvocationList.vue?vue&type=style&index=0&id=5f151ab3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports